import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import BillTo from './BillTo';
import InvoiceOrderDetails from './InvoiceOrderDetails';

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 36
  }
});

const InvoiceBilledTo = ({ customer, invoice, retailerInfo, phone }) => (
  <View style={styles.headerContainer}>
    <BillTo invoice={invoice} customer={customer} phone={phone} />
    <InvoiceOrderDetails invoice={invoice} retailerInfo={retailerInfo} />
  </View>
);

export default InvoiceBilledTo;